import { EntityReducers } from '@core/store/EntityReducers';
import {
  getBaseState,
  getEntityAdapterReducers,
  handleFulfilledAction,
  handleMultipleLoadingActions,
} from '@hwm/ui-lib/core';
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { PMZoneSiteModel } from '@shared/models';
import { thunks } from './PMZoneSitesThunks';

const entityAdapter = createEntityAdapter<PMZoneSiteModel>({});

const slice = createSlice({
  name: EntityReducers.pmZoneSites,
  initialState: {
    ...getBaseState(entityAdapter),
  },
  reducers: {
    ...getEntityAdapterReducers(entityAdapter),
  },
  extraReducers: (builder) => {
    handleMultipleLoadingActions([thunks.getPMZoneSites, thunks.addSiteToPMZone], builder);
    handleFulfilledAction(thunks.getPMZoneSites, builder, (state, payload) => {
      entityAdapter.upsertMany(state, payload);
    });
    handleFulfilledAction(thunks.addSiteToPMZone, builder, () => {});
    handleFulfilledAction(thunks.removeSiteFromPMZone, builder, () => {});
  },
});

export const pmZoneSitesReducer = {
  slice,
  entityAdapter,
  thunks,
};
